export default {

  STORE_REQUEST_TOKEN: 'STORE_REQUEST_TOKEN',
  STORE_ACCESS_TOKEN: 'STORE_ACCESS_TOKEN',

  SET_USER_INFO: 'SET_USER_INFO',
  LOGOUT_USER: 'LOGOUT_USER',
  SET_USER_ACCOMMODATION_INFO: 'SET_USER_ACCOMMODATION_INFO',
  SET_DEFAULT_ACCOMMODATION_INFO: 'SET_DEFAULT_ACCOMMODATION_INFO',

  SET_RESERVED_SPOTS: 'SET_RESERVED_SPOTS',
  RESET_HELD_SPOTS: 'RESET_HELD_SPOTS',
  UPDATE_HELD_SPOTS: 'UPDATE_HELD_SPOTS',
  SET_GEOJSON: 'SET_GEOJSON',
  SET_CURRENT_STATE: 'SET_CURRENT_STATE',

  MAP_ZOOM_IN: 'MAP_ZOOM_IN',
  UPDATE_MAP_POSITION: 'UPDATE_MAP_POSITION',
  MAP_SET_GEOGRAPHY: 'MAP_SET_GEOGRAPHY',
  MAP_SET_LAYERS: 'MAP_SET_LAYERS',
  UPDATE_MAP_ACCOMMODATION_INFO: 'UPDATE_MAP_ACCOMMODATION_INFO',
  UPDATE_BOOKING_OPEN_INFO: 'UPDATE_BOOKING_OPEN_INFO',

  SET_PARKING_SPOT_DETAILS: 'SET_PARKING_SPOT_DETAILS',
  SET_PARKING_SPOT_FEATURES_LIST: 'SET_PARKING_SPOT_FEATURES_LIST',
  UPDATE_BLOCKED_SPOTS_LIST: 'UPDATE_BLOCKED_SPOTS_LIST',
  UPDATE_PREBOOKED_SPOTS_LIST: 'UPDATE_PREBOOKED_SPOTS_LIST',
  UPDATE_PARKING_SPOT_INFOS: 'UPDATE_PARKING_SPOT_INFOS',
  SELECT_PARKING_SPOT: 'SELECT_PARKING_SPOT',
  SET_AREA_SPOTS_MAPPING_LIST: 'SET_AREA_SPOTS_MAPPING_LIST',
  RESET_SELECTED_SPOT: 'RESET_SELECTED_SPOT',
  SELECT_POINT_OF_INTEREST: 'SELECT_POINT_OF_INTEREST',
  RESET_SELECTED_POINT_OF_INTEREST: 'RESET_SELECTED_POINT_OF_INTEREST',
  SET_FILTERED_SPOTS: 'SET_FILTERED_SPOTS',
  PARKING_SPOT_UPDATE_STATUS: 'PARKING_SPOT_UPDATE_STATUS',
  SET_GROUPED_PARKING_SPOTS: 'SET_GROUPED_PARKING_SPOTS',

  SET_DRAWER_STATE: 'SET_DRAWER_STATE',
  SET_NAV_HELP_STATE: 'SET_NAV_HELP_STATE',
  SET_NAV_SEARCH_STATE: 'SET_NAV_SEARCH_STATE',
  SET_NAV_SEARCH_PEOPLE_STATE: 'SET_NAV_SEARCH_PEOPLE_STATE',
  SET_NAV_CHECKOUT_STATE: 'SET_NAV_CHECKOUT_STATE',
  SET_NAV_SPOT_INFO_DETAILED_VIEW: 'SET_NAV_SPOT_INFO_DETAILED_VIEW',

  ADD_MAP_GEO_JSON: 'ADD_MAP_GEO_JSON',

  SET_CHECKOUT_LOADER: 'SET_CHECKOUT_LOADER',
  RESET_CHECKOUT_LOADER: 'RESET_CHECKOUT_LOADER',
  SET_CHECKOUT_DATA: 'SET_CHECKOUT_DATA',
  TOGGLE_BACKEND_RELASE_SPOT_FLAG: 'TOGGLE_BACKEND_RELASE_SPOT_FLAG',
  UPDATE_TIMESTAMP: 'UPDATE_TIMESTAMP',
  UPDATE_CHECKOUT_SPOT_TO_REMOVE: 'UPDATE_CHECKOUT_SPOT_TO_REMOVE',
  RESET_CHECKOUT_DATA: 'RESET_CHECKOUT_DATA',
  SET_CHECKOUT_EVENT: 'SET_CHECKOUT_EVENT',
  SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
  SET_SEARCH_RESULT: 'SET_SEARCH_RESULT',
  RESET_SEARCH: 'RESET_SEARCH',
  RESET_NAV_OPTIONS: 'RESET_NAV_OPTIONS',
  RESET_MAP: 'RESET_MAP',

  SET_FILTER_OPTIONS: 'SET_FILTER_OPTIONS',
  APPLY_FILTERS: 'APPLY_FILTERS',
  RESET_FILTERS: 'RESET_FILTERS',
  SET_SEARCH_LOADING: 'SET_SEARCH_LOADING',
  RESET_SEARCH_LOADING: 'RESET_SEARCH_LOADING',

  SET_REQUEST_ID: 'SET_REQUEST_ID',

  SET_PUSHER_SOCKET_ID: 'SET_PUSHER_SOCKET_ID',

  ADD_TOASTER_MESSAGE: 'ADD_TOASTER_MESSAGE',
  DELETE_TOASTER_MESSAGE_BY_ID: 'DELETE_TOASTER_MESSAGE_BY_ID',
  SET_DEFAULT_STATE_TIMESTAMP: 'SET_DEFAULT_STATE_TIMESTAMP',
  SET_USER_DATA_FETCH_TIMESTAMP: 'SET_USER_DATA_FETCH_TIMESTAMP',

  TOGGLE_PARKING_AREA_MARKERS: 'TOGGLE_PARKING_AREA_MARKERS',
  TOGGLE_PARKING_SPOT_MARKERS: 'TOGGLE_PARKING_SPOT_MARKERS',
  TOGGLE_PARKING_SPOT_MARKERS_LABEL: 'TOGGLE_PARKING_SPOT_MARKERS_LABEL',
};



// WEBPACK FOOTER //
// ./src/actions/types.js